import React from 'react'
import CommWhatsAppCompose from './CommWhatsAppCompose'

// Created By Cursor
const CommComposeAttendance = (props) => (
  <CommWhatsAppCompose {...props} titleHint="Attendance" />
)

export default CommComposeAttendance
